// extracted by mini-css-extract-plugin
module.exports = {"steps":"steps_steps__25VyW","icon":"steps_icon__1LNrJ","done":"steps_done__10qBG","text":"steps_text__1e08i","line":"steps_line__1pH24","active":"steps_active__3PfLg"};